<template>
  <div :class="['page_view', printFormat ? 'print' : 'screen' ]">
    <div v-if="printFormat">
      <print-resume :accessCode="access" @loaded="loaded"/>
    </div>
    <div v-else>
      <screen-resume :code="access" />
    </div>
  </div>
</template>

<script>

import PrintResume from '@/components/print-resume';
import ScreenResume from '@/components/screen-resume';

export default {
    name       : "Resume",
    components : { PrintResume, ScreenResume },
    props      : {
        access : {
            type : String
        },
        format : {
            type : String
        },
        autoPrint : {
            type    : Boolean,
            default : false
        }
    },
    data() {
        return {
            printAttempted : false
        };
    },
    computed : {
        printFormat() {
            return (this.format === 'print');
        }
    },
    methods : {
        loaded() {
            if (this.autoPrint && ! this.printAttempted) {
                this.printAttempted = true;
                window.print();
            }
        }
    }
};

</script>

<style scoped>

.page_view {
    width:100%;
}

.page_view.print {
    background-color:var(--core-white);
    min-height:calc(100%);
}

@media only screen and (max-width:500px) {
    .page_view.print {
        overflow:auto;
    }
}

@media print {
    .page_view.screen {
        width:80%;
    }
}

</style>
